/* CCC 2026-09-30 – Lesefortschritt, Kapitelname und «Inhalt»-Knopf für sections/ccc27-read.liquid.
   Die Kapitel kommen aus dem Inhaltsverzeichnis im Seiteninhalt (Links auf #sprungmarken).
   Gibt es weniger als drei, bleibt die Leiste weg.
   CCC 2026-10-01: «Dimensionen sammeln» – pro gelesenem Kapitel leuchtet ein Punkt in der Leiste auf.
   Gelesen heisst: zusammengerechnet mind. 2 Sekunden im mittleren Bildbereich und einmal bis zum
   Kapitelende gescrollt. Wer nur durchspringt, sammelt nichts.
   CCC 2026-10-01: Stil «papagei» – Kapitelwort mit Original-Papagei auf dem letzten Buchstaben,
   Hüpfer beim Fund, am Schluss kurz Pink mit angeschnittenem Signet. */
(function () {
  if (window.cccReadInit) return;
  window.cccReadInit = true;

  var DWELL_MS = 2000;
  var TICK_MS = 250;

  function fill(tpl, vars) {
    var s = tpl || '';
    Object.keys(vars).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
    return s;
  }

  function init() {
    var root = document.querySelector('[data-ccc-read]');
    if (!root) return;
    var bar = root.querySelector('[data-ccc-rd-bar]');
    var body = root.querySelector('.ccc27-read__body');
    if (!bar || !body) return;
    var sum = root.querySelector('.ccc27-read__sum');
    var art = body.querySelector('article') || body;
    var btn = bar.querySelector('[data-ccc-rd-btn]');
    var panel = bar.querySelector('[data-ccc-rd-toc]');
    var list = panel.querySelector('ol');
    var now = bar.querySelector('[data-ccc-rd-now]');
    var fillBar = bar.querySelector('[data-ccc-rd-fill]');
    var intro = bar.getAttribute('data-intro') || '';
    var parrotMode = bar.getAttribute('data-style') === 'papagei' && !!bar.querySelector('template[data-ccc-rd-parrot]');
    var words = {};
    (bar.getAttribute('data-words') || '').split(/\n/).forEach(function (line) {
      var i = line.indexOf(':');
      if (i < 1) return;
      var k = line.slice(0, i).trim().replace(/^#/, '');
      var v = line.slice(i + 1).trim();
      if (k && v) words[k] = v;
    });
    var parrotTpl = parrotMode ? bar.querySelector('template[data-ccc-rd-parrot]') : null;
    var finEl = bar.querySelector('[data-ccc-rd-fin]');
    var wordEl = null;
    var parrotEl = null;

    var seen = {};
    var items = [];
    body.querySelectorAll('nav a[href^="#"]').forEach(function (a) {
      var id = decodeURIComponent(a.getAttribute('href').slice(1));
      if (!id || seen[id]) return;
      var target = document.getElementById(id);
      if (!target || !body.contains(target)) return;
      seen[id] = true;
      items.push({ id: id, el: target, label: a.textContent.replace(/\s+/g, ' ').trim(), sub: !!a.closest('.toc-sub') });
    });
    if (items.length < 3) return;
    items.sort(function (x, y) {
      return x.el.compareDocumentPosition(y.el) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });
    items.forEach(function (it) {
      var li = document.createElement('li');
      if (it.sub) li.className = 'is-sub';
      var a = document.createElement('a');
      a.href = '#' + it.id;
      a.textContent = it.label;
      li.appendChild(a);
      list.appendChild(li);
      it.link = a;
      it.li = li;
    });

    /* CCC 2026-10-02: Leiste an die Kopfzeile andocken (wie ccc27-pread.js). Vorher wurde ihre Position bei jedem
       Scroll per JS (--rd-top) gesetzt; auf dem iPhone hinkte das hinterher (Lücke, Zucken). Die Hülle trägt die
       ccc27-read-Klassen der Seite, damit alle Stile der Leiste unverändert greifen. */
    var dockEl = document.createElement('div');
    dockEl.className = ['ccc27-rd-dock'].concat(root.className.split(/\s+/).filter(function (k) { return /^ccc27-read/.test(k); })).join(' ');
    if (root.getAttribute('style')) dockEl.setAttribute('style', root.getAttribute('style'));
    function dock() {
      var h = document.querySelector('.header-section') || document.querySelector('[id$="__header"]');
      var target = h || document.body;
      if (dockEl.parentNode !== target) target.appendChild(dockEl);
      if (bar.parentNode !== dockEl) dockEl.appendChild(bar);
      dockEl.classList.toggle('is-docked', !!h);
      return h;
    }
    var header = dock();
    var dotsBtn = bar.querySelector('[data-ccc-rd-dots]');
    var toggles = [btn];

    function setOpen(open) {
      panel.hidden = !open;
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (open) hideToast();
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { setOpen(false); btn.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !bar.contains(e.target)) setOpen(false);
    });
    panel.addEventListener('click', function (e) { if (e.target.closest('a')) setOpen(false); });

    /* ---------- Meldung unter der Leiste ---------- */
    var toastEl = bar.querySelector('[data-ccc-rd-toast]');
    var liveEl = bar.querySelector('[data-ccc-rd-live]');
    var toastTimer = null;
    function hideToast() {
      if (!toastEl) return;
      toastEl.classList.remove('is-show');
      clearTimeout(toastTimer);
    }
    function toast(text, ms, link) {
      if (!toastEl) return;
      toastEl.textContent = '';
      toastEl.appendChild(document.createTextNode(text));
      var said = text;
      if (link && link.label && link.href) {
        toastEl.appendChild(document.createTextNode(' '));
        var a = document.createElement('a');
        a.href = link.href;
        a.textContent = link.label + ' ›';
        a.addEventListener('click', hideToast);
        toastEl.appendChild(a);
        said += ' ' + link.label;
      }
      toastEl.classList.add('is-show');
      if (liveEl) liveEl.textContent = said;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove('is-show'); }, ms);
    }

    /* ---------- Dimensionen sammeln ---------- */
    var dims = [];
    var foundCount = 0;
    var hintShown = false;
    var cnt = null;
    var cfg = {};
    if (dotsBtn) {
      cfg = {
        aria: dotsBtn.getAttribute('data-aria') || '',
        count: dotsBtn.getAttribute('data-count') || '{n}/{total}',
        found: dotsBtn.getAttribute('data-found') || '{name}',
        hint: dotsBtn.getAttribute('data-hint') || '',
        done: dotsBtn.getAttribute('data-done') || '',
        doneLink: dotsBtn.getAttribute('data-done-link') || '',
        doneHref: dotsBtn.getAttribute('data-done-href') || ''
      };
      (dotsBtn.getAttribute('data-ids') || '').split(',').forEach(function (raw) {
        var id = raw.trim().replace(/^#/, '');
        for (var i = 0; i < items.length; i++) {
          if (items[i].id === id) { dims.push({ it: items[i], ms: 0, end: false, found: false }); break; }
        }
      });
      if (dims.length >= 2) {
        var set = dotsBtn.querySelector('.ccc27-rd-bar__dotset');
        cnt = dotsBtn.querySelector('.ccc27-rd-bar__cnt');
        dims.forEach(function (d) {
          d.dot = document.createElement('i');
          set.appendChild(d.dot);
          d.it.li.classList.add('is-dim');
          d.tile = body.querySelector('.ccc27-rd__tile[href="#' + d.it.id + '"]');
        });
        dotsBtn.hidden = false;
        toggles.push(dotsBtn);
        dotsBtn.addEventListener('click', function () { setOpen(panel.hidden); });
        renderCount();
      } else {
        dims = [];
      }
    }
    btn.addEventListener('click', function () { setOpen(panel.hidden); });

    function renderCount() {
      var vars = { n: foundCount, total: dims.length };
      cnt.textContent = foundCount + '/' + dims.length;
      dotsBtn.setAttribute('aria-label', fill(cfg.aria, vars) || fill(cfg.count, vars));
      dotsBtn.classList.toggle('is-done', foundCount === dims.length);
    }

    function markFound(d) {
      d.found = true;
      foundCount++;
      d.dot.classList.add('is-on', 'is-pop');
      setTimeout(function () { d.dot.classList.remove('is-pop'); }, 600);
      d.it.li.classList.add('is-found');
      if (d.tile) d.tile.classList.add('is-found');
    }

    function hop() {
      if (parrotEl) {
        parrotEl.classList.remove('is-hop');
        void parrotEl.getBoundingClientRect();
        parrotEl.classList.add('is-hop');
        var el = parrotEl;
        setTimeout(function () { el.classList.remove('is-hop'); }, 800);
      }
      if (cnt) {
        cnt.classList.remove('is-pop');
        void cnt.getBoundingClientRect();
        cnt.classList.add('is-pop');
        setTimeout(function () { cnt.classList.remove('is-pop'); }, 600);
      }
    }

    var finTimer = null;
    function finale(vars) {
      if (!finEl || !bar.classList.contains('is-on')) return false;
      var t = finEl.querySelector('.ccc27-rd-fin__t');
      t.textContent = fill(t.getAttribute('data-title'), vars);
      setOpen(false);
      hideToast();
      bar.classList.add('is-finale');
      var link = finEl.querySelector('a');
      if (link && !link.cccBound) {
        link.cccBound = true;
        link.addEventListener('click', function () { bar.classList.remove('is-finale'); });
      }
      clearTimeout(finTimer);
      finTimer = setTimeout(function () { bar.classList.remove('is-finale'); }, 7000);
      return true;
    }

    function tick() {
      if (!dims.length || foundCount === dims.length || document.hidden) return;
      var vh = window.innerHeight;
      var fresh = [];
      dims.forEach(function (d) {
        if (d.found) return;
        var r = d.it.el.getBoundingClientRect();
        if (r.top < vh * 0.7 && r.bottom > vh * 0.2) d.ms += TICK_MS;
        if (r.bottom < vh * 0.85 && r.bottom > 0) d.end = true;
        if (d.ms >= DWELL_MS && d.end) fresh.push(d);
      });
      if (!fresh.length) return;
      fresh.forEach(markFound);
      renderCount();
      var vars = { n: foundCount, total: dims.length };
      if (parrotMode) {
        hop();
        var said = fresh.length === 1 ? fill(cfg.found, { name: fresh[0].it.label }) + ' · ' + fill(cfg.count, vars) : fill(cfg.count, vars);
        if (foundCount === dims.length) {
          said = fill(finEl ? finEl.querySelector('.ccc27-rd-fin__t').getAttribute('data-title') : cfg.done, vars);
          if (!finale(vars)) toast(fill(cfg.done, vars), 7000, { label: cfg.doneLink, href: cfg.doneHref });
        }
        if (liveEl) liveEl.textContent = said;
        return;
      }
      if (foundCount === dims.length) {
        toast(fill(cfg.done, vars), 7000, { label: cfg.doneLink, href: cfg.doneHref });
      } else if (fresh.length === 1) {
        toast(fill(cfg.found, { name: fresh[0].it.label }) + ' · ' + fill(cfg.count, vars), 2600);
      } else {
        toast(fill(cfg.count, vars), 2600);
      }
    }
    if (dims.length) setInterval(tick, TICK_MS);

    /* ---------- Papagei: Kapitelwort ---------- */
    /* CCC 2026-10-02: in einem Schritt statt Schleife (weniger Layout-Arbeit beim schnellen Scrollen) */
    function fit() {
      if (!wordEl) return;
      wordEl.style.fontSize = '';
      var max = now.parentElement ? now.parentElement.clientWidth : 0;
      if (!max) return;
      var w = wordEl.getBoundingClientRect().width;
      if (w <= max) return;
      var size = parseFloat(window.getComputedStyle(wordEl).fontSize) || 30;
      wordEl.style.fontSize = Math.max(18, Math.floor(size * max / w)) + 'px';
    }
    function setWord(idx) {
      var it = idx >= 0 ? items[idx] : null;
      var w = it ? (words[it.id] || it.label) : (words.intro || intro);
      var chars = Array.from(w.trim());
      now.textContent = '';
      var sr = document.createElement('span');
      sr.className = 'visually-hidden';
      sr.textContent = it ? it.label : intro;
      wordEl = document.createElement('span');
      wordEl.className = 'ccc27-rd-word';
      wordEl.setAttribute('aria-hidden', 'true');
      wordEl.appendChild(document.createTextNode(chars.slice(0, -1).join('')));
      var pl = document.createElement('span');
      pl.className = 'ccc27-pl';
      pl.appendChild(document.createTextNode(chars.slice(-1).join('')));
      parrotEl = parrotTpl.content.firstElementChild.cloneNode(true);
      pl.appendChild(parrotEl);
      wordEl.appendChild(pl);
      now.appendChild(sr);
      now.appendChild(wordEl);
      fit();
    }
    if (parrotMode) {
      setWord(-1);
      window.addEventListener('resize', function () { fit(); });
    }

    /* ---------- Leiste, Fortschritt, Kapitelname ---------- */
    var current = -2;
    var ticking = false;
    var free = null;
    function update() {
      ticking = false;
      if (!dockEl.isConnected || (header && !header.isConnected)) header = dock();
      /* Nur lesen, nie Pixel setzen: Kopfzeile sichtbar = Leiste hängt daran, sonst fix oben */
      var hb = header ? header.getBoundingClientRect().bottom : 0;
      var isFree = !(hb > 0.5);
      if (isFree !== free) { free = isFree; dockEl.classList.toggle('is-free', isFree); }
      var top = isFree ? 0 : Math.round(hb);
      var a = art.getBoundingClientRect();
      var startEdge = sum ? sum.getBoundingClientRect().bottom : a.top;
      var wasOn = bar.classList.contains('is-on');
      /* 40 px Spielraum beim Ausblenden, damit die Leiste an den Schwellen nicht flackert */
      var on = wasOn ? (startEdge < top + 40 && a.bottom > top + 120) : (startEdge < top && a.bottom > top + 160);
      bar.classList.toggle('is-on', on);
      if (on && !wasOn && parrotMode) fit();
      if (!on) {
        bar.classList.remove('is-finale');
        if (!panel.hidden) setOpen(false);
        hideToast();
        return;
      }
      if (dims.length && !hintShown && cfg.hint) {
        hintShown = true;
        if (foundCount === 0) toast(fill(cfg.hint, { total: dims.length }), 4500);
      }
      var span = a.height - (window.innerHeight - top);
      var done = span > 0 ? Math.min(1, Math.max(0, (top - a.top) / span)) : 1;
      fillBar.style.transform = 'scaleX(' + done.toFixed(3) + ')';
      var idx = -1;
      for (var i = 0; i < items.length; i++) {
        if (items[i].el.getBoundingClientRect().top <= top + 100) idx = i;
        else break;
      }
      if (idx !== current) {
        current = idx;
        if (parrotMode) setWord(idx);
        else now.textContent = idx >= 0 ? items[idx].label : intro;
        items.forEach(function (it, k) {
          if (k === idx) it.link.setAttribute('aria-current', 'true');
          else it.link.removeAttribute('aria-current');
        });
      }
    }
    function schedule() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    update();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
